import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';


@Component({
    selector: 'app-fertigation-dashboard',
    template: `
    <agr-powerbi-report [workspaceId]="workspaceId" [reportId]="reportId"/>`,
    imports: [PowerbiReportComponent],
})
export class FertigationDashboardComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.FERTIGATION_DASHBOARD_WORKSPACE_ID;
    this.reportId = this.env.FERTIGATION_DASHBOARD_REPORT_ID;
  }
}
